<template>
<div class="kanban-container">
    <div v-for="stage in stages" class="kanban-region elevation-3" :key="stage.value" >
        <!-- Header -->
        <div class="pa-2" style="background-color:#eee;border-radius:5px;font-weight:600;color:#666">
            {{stage.text}} 
        </div>
        <!-- Body -->
        <div class="pa-2 kanban-body">
            <div class="kanban-counter">{{getItemsForRegion(stage.value).length}}</div>
            <draggable :data-stage="stage.value" :data-stage-text="stage.text" style="width:100%;height:100%;min-height:200px" class="draggable-container" :options="{ animation: 350, group:'kanban', xxxhandle: '.menu-icon'}" @end="afterDrag" :key="stage.value">
            <div v-for="item in getItemsForRegion(stage.value)" :data-id="getItemId(item)" :key="getItemId(item)" @click="itemClicked(item)">
                <slot v-bind:item="item">
                    <div class="kanban-item hoverable clickable">
                    {{item.clients}} <span class="light-text">{{item.title}}</span>asdfasdf
                    </div>
                </slot>
            </div>
            </draggable>
        </div>
        
    </div>

</div>
</template>

<script>
import draggable from 'vuedraggable'
import LookupData from '../helpers/LookupData'
import ArrayHelpers from '../helpers/ArrayHelpers'
import StringHelpers from '../helpers/StringHelpers'

import ContactHelpers from '../helpers/ContactHelpers'
import NiceData from '../data/NiceData'
import TenantHelpers from '../helpers/TenantHelpers'
import {differenceInCalendarDays} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers'
import TransactionHelpers from '../helpers/TransactionHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import DataHelpers from '../helpers/DataHelpers'
import Utilities from '../helpers/Utilities'

export default {
data() {
    return {
        
    }
},

props: {
    items: Array,
    stages: Array,
    fieldPath: String,
},
components: {
    draggable
},

computed: {

},

methods: {

    afterDrag(e) {
        
        let changes = {
            id: e.item.dataset.id,
            to: e.item.parentNode.dataset.stage,
            toText: e.item.parentNode.dataset.stageText,
            from: e.from.dataset.stage,
            fromText: e.from.dataset.stageText,
        }
        this.$emit('move', changes)
    },

    itemClicked(item) {
        this.$emit('click', item)
    },

    getItemId(item) {
        return item._id || item._key || item.key || (item.meta ? item.meta.key : null)
    },

    getItemsForRegion(region) {
        let matches = []
        this.items.forEach(item => {
            const fieldValue = Utilities.objectDeepGet(item, this.fieldPath)
            if(fieldValue == region)
                matches.push(item)
        })
        return matches
    }

    // taskClicked(task) {
    //     console.log('taskClicked', task)
    //     TenantHelpers.setTenant(task.meta.tenantKey)
    //     this.$emit('clicked', task)
    // },
       
}
}
</script>

<style scoped>

.kanban-region {
    min-width:150px;
    margin:7px;
    background-color:white;
    border-radius:5px;
    flex-grow:1
}
.kanban-container {
    display:flex;
    flex-wrap:wrap;
    background-color: #999;
    width:100%;
    padding:7px;
}
.kanban-body {
    overflow-y:auto;
    position:relative;
}
.kanban-item {
    width:250px;
    margin:2px;
    border-radius:3px;
    padding:5px;
    border:dotted 1px #ccc;
}
.kanban-counter {
    z-index:1;position:absolute;right:-4px;top:-8px;width:40px;height:40px;background-color:rgba(190,190,190,0.5);color: white;text-align:center;border-radius:20px;font-size:24px;font-weight:600;padding-top:3px;
}


</style>




// WEBPACK FOOTER //
// KanbanView.vue?10bc2f94